import React from "react";
import * as Icon from "react-bootstrap-icons";
import {NavLink, useNavigate} from "react-router-dom";
import Role from "../../inc/Role";
import toast, { Toaster } from 'react-hot-toast';

import * as Utils from "../../inc/Utils";
import Select from 'react-select'
import {Config} from "../../Config";
import * as XLSX from 'xlsx';
import {confirmAlert} from "react-confirm-alert";
import moment from "moment-timezone";
import AdsCampaignTemplateAlwaysOn from "../../download/AdsCampaign_AlwayOn_Template_Import.xlsx";
import AdsCampaignTemplateAdHoc from "../../download/AdsCampaign_AdHoc_Template_Import.xlsx";
import DownloadCustomerURL from "../../download/generate_special_customurl_import.xlsx";
import DownloadBgZone from "../../download/generate_special_bgzone_import.xlsx";
import DownloadCombineZone from "../../download/generate_special_combiezone_import.xlsx";
import DownloadEventReminder from "../../download/generate_special_eventreminder_import.xlsx";
import DownloadStaticPage from "../../download/generate_special_import_staticpage.xlsx";

export default function AdsNamingSetnameImport() {
    const roles = new Role();
    let userId = roles.loginUserId;

    const navigate = useNavigate();

    let btnTextDefault = 'ดาวน์โหลดเทมเพลต';
    let btnTextLoading = 'กำลังดาวน์โหลด..';
    let [isLoading, setLoading] = React.useState(false);

    let btnTextUploadDefault = 'อัพโหลด';
    let btnTextUploading = 'กำลังอัพโหลด..';
    let [isUploading, setUploading] = React.useState(false);
    let [isUploaded, setUploaded] = React.useState(false);

    let btnTextImportDefault = 'นำเข้าระบบ & ดาวน์โหลด';
    let btnTextImporting = 'กำลังนำเข้า..';
    let [isImporting, setImporting] = React.useState(false);

    let [type, setType] = React.useState('');
    let [adsGroup, setAdsGroup] = React.useState('');
    let [kolPage, setKolPage] = React.useState('');
    let [platform, setPlatform] = React.useState('');

    let [lang, setLanguage] = React.useState(null);
    let [typeId, setTypeId] = React.useState(null);
    let [adsGroupId, setAdsGroupId] = React.useState(null);
    let [excelFile, setExcelFile] = React.useState(false);
    let [disableImport, setDisableImport] = React.useState(true);
    let [previewParams, setPreviewParams] = React.useState('');
    let [langIds, setLangIds] = React.useState([]);
    let [projectTypeIds, setProjectTypeIds] = React.useState([]);
    let [projectType, setProjectType] = React.useState(null);
    let [buTypeIds, setBuTypeIds] = React.useState([]);
    let [sourceTypeAllIds, setSourceTypeAllIds] = React.useState([]);

    let [isCustomUrl, setIsCustomUrl] = React.useState(true);
    let [specialFilterId, setSpecialFilterId] = React.useState(null);
    let [specialFilter, setSpecialFilter] = React.useState(null);
    let [zoneStatus, setZoneStatus] = React.useState(null);

    React.useEffect(() => {
        (async function() {
            try {
                const resType = await Utils.getAdsType();
                setType(resType);

                const resFilter = await Utils.getAdsNamingSpecialFilter();
                setSpecialFilter(resFilter);

                const resZoneStatus = await Utils.getAdsNamingZoneStatus();
                setZoneStatus(resZoneStatus);

                const resPlatform = await Utils.getPlatformAll();
                setPlatform(resPlatform);

                //region language
                let langIds = [];
                const resLang = await Utils.getLanguage();
                setLanguage(resLang);
                if(resLang) {
                    for(let rs of resLang) {
                        let id = rs.id;
                        if(id) {
                            langIds.push(id);
                        }
                    }
                }
                setLangIds(langIds);
                //endregion

                //region project type
                let projectTypeIds = [];
                const resPJType = await Utils.getProjectType();
                setProjectType(resPJType);
                if(resPJType) {
                    for(let rs of resPJType) {
                        let id = rs.id;
                        if(id) {
                            projectTypeIds.push(id);
                        }
                    }
                }
                setProjectTypeIds(projectTypeIds);
                //endregion

                //region bu type
                let buTypeIds = [];
                const resBuType = await Utils.getBuType();
                if(resBuType) {
                    for(let rs of resBuType) {
                        let id = rs.id;
                        if(id) {
                            buTypeIds.push(id);
                        }
                    }
                }
                setBuTypeIds(buTypeIds);
                //endregion

            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    async function getGroupView(groupId) {
        const response = await fetch(Config.url.API_URL +'/api/adsSetnameGroup/view', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': roles.accessToken
            },
            body: JSON.stringify({
                id: groupId
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    async function getProject(lang, project_type, campaign_date) {
        // + '&project_code=' +project_code + '&campaign_id=' + campaign_id
        const response = await fetch(Config.url.AP_API_URL + '/api/projects/campaigns?lang=' + lang+ '&project_type=' + project_type + '&campaign_date=' + campaign_date + '&limit=2000', {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-api-key': Config.AP_API_KEY
            }
        });

        return response.json();
    }

    async function getPromotion(lang, campaign_type, bu_type, campaign_date) {
        let url = Config.url.AP_API_URL + '/api/promotions/urls?lang=' + lang + '&campaign_type=' + campaign_type + '&bu_type=' + bu_type;

        if(campaign_date) {
            url += '&campaign_date=' + (campaign_date ? Utils.dateYMD(campaign_date, '-') : '');
        }
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'x-api-key': Config.AP_API_KEY
            }
        });

        return response.json();
    }

    const onChangeTypeId = async (obj) => {
        setTypeId(obj);
        setAdsGroup('');
        setAdsGroupId(null);
        setPreviewParams('');
        setExcelAlwaysOnPreview('');
        setExcelAlwaysOnPreviewError('');
        setExcelAdHocPreview('');
        setExcelAdHocPreviewError('');
        if(excelFile && excelFile.target) {
            excelFile.target.value = '';
        }
        if(obj) {
            const resGroup = await Utils.getAdsSetnameGroup(obj.id);
            setAdsGroup(resGroup);
        }
    };

    const onDownload = () => {
        if(!typeId) {
            toast.error("กรุณาระบุ Type");
        }
        else {
            let url = '';
            if(typeId.id === Utils.ADSNAMING_GROUP_ALWAYS_ON) {
                url = AdsCampaignTemplateAlwaysOn;

            }
            else if(typeId.id === Utils.ADSNAMING_GROUP_ADHOC_CAMPAIGN) {
                url = AdsCampaignTemplateAdHoc;
            }
            else if(typeId.id === Utils.ADSNAMING_GROUP_SPECIAL) {
                if(isCustomUrl) {
                    url = DownloadCustomerURL;
                }
                else {
                    if(specialFilterId && specialFilterId.id) {
                        if(specialFilterId.id === Utils.ADS_NAMING_SPECIAL_FILTER_BG_ZONE) {
                            url = DownloadBgZone;
                        }
                        else if(specialFilterId.id === Utils.ADS_NAMING_SPECIAL_FILTER_COMBINE_ZONE) {
                            url = DownloadCombineZone;
                        }
                        else if(specialFilterId.id === Utils.ADS_NAMING_SPECIAL_FILTER_EVENT_REMINDER) {
                            url = DownloadEventReminder;
                        }
                        else if(specialFilterId.id === Utils.ADS_NAMING_SPECIAL_FILTER_STATIC_PAGE) {
                            url = DownloadStaticPage;
                        }
                    }
                    else {
                        toast.error("กรุณาระบุ Filter Type");
                    }
                }
            }
            if(url) {
                const a = document.createElement('a');
                a.href = url;
                a.download = url.split('/').pop();
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }
        }
    };

    let [data, setData] = React.useState('');
    let [showExcelAlwaysOnPreview, setExcelAlwaysOnPreview] = React.useState('');
    let [showExcelAlwaysOnPreviewError, setExcelAlwaysOnPreviewError] = React.useState('');
    let [showExcelAdHocPreview, setExcelAdHocPreview] = React.useState('');
    let [showExcelAdHocPreviewError, setExcelAdHocPreviewError] = React.useState('');
    let [showExcelSpecialPreview, setExcelSpecialPreview] = React.useState('');
    let [showExcelSpecialPreviewError, setExcelSpecialPreviewError] = React.useState('');

    const onChangeGroupId = async (obj) => {
        if(obj && obj.id) {
            setAdsGroupId(obj);
            setPreviewParams(null);

            const data = await getGroupView(obj.id);
            setData(data);

            let showPreview = [];
            let sourceTypeAllIdsTmp = [];
            if(data.groupItem) {
                for(let item of data.groupItem) {
                    let adsSetnameGroupId = item.adsSetnameGroupId;
                    let adsNamingSetNameTypeId = item.adsNamingSetNameTypeId;
                    let itemName = item.name;
                    let itemSource = item.itemSource;
                    let adsPlatformId = item.adsPlatformId;
                    if(itemSource) {
                        let sourceTypeTextParam = [];
                        for(let rs of itemSource) {
                            if(rs.inputType === Utils.ADSNAMING_TYPE_KOL_PAGE) {
                                sourceTypeTextParam.push('x:KOL' + rs.adsNamingSourceId);
                            }
                            else if(rs.inputType === Utils.ADSNAMING_TYPE_FREEFORM) {
                                sourceTypeTextParam.push(rs.text);
                            }
                            else if(rs.inputType === Utils.ADSNAMING_TYPE_SLUG_PROJECT) {
                                sourceTypeTextParam.push('{slugProject}');
                            }
                            else if(rs.inputType === Utils.ADSNAMING_TYPE_SLUG_PROMOTION) {
                                sourceTypeTextParam.push('{slugPromotion}');
                            }
                            else if(rs.inputType === Utils.ADSNAMING_TYPE_SLUG_SPECIAL) {
                                sourceTypeTextParam.push('{slugSpecial}');
                            }
                            else {
                                sourceTypeTextParam.push(rs.text);
                            }
                        }

                        sourceTypeAllIdsTmp.push({
                            adsPlatformId: adsPlatformId,
                            adsNamingSetNameTypeId: adsNamingSetNameTypeId,
                            itemSource: itemSource,
                            params: sourceTypeTextParam
                        });

                        showPreview.push({
                            adsSetnameGroupItemId: adsSetnameGroupId,
                            itemName: itemName,
                            params : await getParams(sourceTypeTextParam, adsNamingSetNameTypeId, adsPlatformId)
                        });
                    }
                }
            }
            setPreviewParams(showPreview);
            setSourceTypeAllIds(sourceTypeAllIdsTmp);
        }
    };

    const onSelectFile = (e) => {
        setExcelFile(e);
    };

    const onUpload = async () => {
        if(!typeId) {
            toast.error("กรุณาระบุ Type");
        }
        else if(!adsGroupId) {
            toast.error("กรุณาระบุ Group");
        }
        else if(!previewParams || previewParams.length <= 0) {
            toast.error("ไม่พบ Group Item");
        }
        else if(!excelFile || typeof excelFile.target === 'undefined') {
            toast.error("กรุณาระบุ Excel File");
        }
        else {
            setUploading(true);
            setExcelAlwaysOnPreview('');
            setExcelAdHocPreview('');

            const [file] = excelFile.target.files;
            const reader = new FileReader();

            reader.onload = async (evt) => {
                const bstr = evt.target.result;
                const wb = XLSX.read(bstr, { type: "binary" });
                const wsname = wb.SheetNames[0];
                const ws = wb.Sheets[wsname];
                const data = XLSX.utils.sheet_to_csv(ws, { header: 1 });

                if(data) {
                    let row = data.split('\n');
                    //Check Header
                    let header = row[0];
                    if(typeId.id === Utils.ADSNAMING_GROUP_ALWAYS_ON) {
                        let cols = header.split(',');
                        if(cols[0] !== 'Lang') {
                            setUploading(false);
                            toast.error("Column 1 : ต้องเป็น(ชื่อ) Lang");
                            return;
                        }
                        else if(cols[1] !== 'Project Type') {
                            setUploading(false);
                            toast.error("Column 2 : ต้องเป็น(ชื่อ) Project Type");
                            return;
                        }
                        else if(cols[2] !== 'Project Code') {
                            setUploading(false);
                            toast.error("Column 3 : ต้องเป็น(ชื่อ) Project Code");
                            return;
                        }
                        else if(cols[3] !== 'Campaign ID') {
                            setUploading(false);
                            toast.error("Column 4 : ต้องเป็น(ชื่อ) Campaign ID");
                            return;
                        }
                        else if(cols[4] !== 'Campaign Date') {
                            setUploading(false);
                            toast.error("Column 5 : ต้องเป็น(ชื่อ) Campaign Date");
                            return;
                        }

                        if(row.length > 0) {
                            let message = [];
                            let statusAll = [];
                            let projectList = [];
                            let projectListError = [];

                            for(let i=1;i<row.length;i++) {
                                let cols = row[i].split(',');
                                let colLang = cols[0].toString().trim();
                                let colProjectType = cols[1].toString().trim();
                                let colProjectCode = cols[2].toString().trim();
                                let colCampaignId = cols[3].toString().trim();
                                let colCampaignDate = Utils.dateFromExcel(cols[4].toString().trim());

                                let status = 0;
                                if(colLang && colProjectType && colProjectCode) {

                                    let statusLang = true;
                                    if(langIds && !langIds.includes(colLang)) {
                                        status = 2;
                                        statusLang = false;
                                        message.push('Invalid Lang');
                                    }
                                    else {
                                        statusLang = true;
                                    }

                                    let statusProjectType = true;
                                    if(projectTypeIds && !projectTypeIds.includes(colProjectType)) {
                                        status = 2;
                                        statusProjectType = false;
                                        message.push('Invalid Project Type');
                                    }
                                    else {
                                        statusProjectType = true;
                                    }

                                    let statusProjectCode = true;
                                    let statusCampaignId = true;

                                    let statusCampaignDate = true;
                                    let url = '';
                                    let projectId = '';
                                    let projectSlug = '';
                                    let projectTypeSlug = '';
                                    let campaignName = '';
                                    let projectCodeArr = [];
                                    let campaignIdArr = [];

                                    if(!colCampaignDate) {
                                        status = 2;
                                        statusCampaignDate = false;
                                        message.push('Invalid campaign date');
                                    }
                                    else if(statusLang && statusProjectType) {
                                        status = 2;
                                        statusCampaignDate = true;
                                        const projectResult = await getProject(colLang, colProjectType, colCampaignDate);
                                        if(projectResult && projectResult.data.length > 0) {
                                            for(let rs of projectResult.data) {
                                                if(rs.project_code === colProjectCode) {
                                                    url = rs.project_url;
                                                    projectId = rs.project_code;
                                                    projectSlug = colLang + '-' + colProjectType + '-' + rs.project_slug;
                                                    projectTypeSlug = rs.project_type_slug;
                                                    if(rs.promotions.length > 0) {
                                                        if(colCampaignId === '0638A01') {
                                                            status = 1;
                                                            break;
                                                        }
                                                        else {
                                                            for(let pr of rs.promotions) {
                                                                campaignName = pr.campaign_name;
                                                                if(pr.campaign_id === colCampaignId) {
                                                                    status = 1;
                                                                    break;
                                                                }
                                                                else {
                                                                    campaignIdArr.push(1);
                                                                }
                                                            }
                                                        }
                                                    }
                                                    else {
                                                        message.push(projectResult.message);
                                                    }
                                                }
                                                else {
                                                    projectCodeArr.push(2);
                                                }
                                            }
                                        }
                                        else {
                                            message.push(projectResult.message);
                                        }
                                    }

                                    if(status === 1) {
                                        projectCodeArr = [];
                                        campaignIdArr = [];
                                    }

                                    if(campaignIdArr.length > 0) {
                                        statusCampaignId = false;
                                        status = 2;
                                        message.push('Campaign ID not found');
                                    }
                                    else if(projectCodeArr.length > 0) {
                                        statusProjectCode = false;
                                        status = 2;
                                        message.push('Project Code not found');
                                    }

                                    projectCodeArr = [];
                                    campaignIdArr = [];

                                    if(status === 1) {
                                        projectList.push({
                                            lang: colLang,
                                            projectType: colProjectType,
                                            projectCode: colProjectCode,
                                            campaignId: colCampaignId,
                                            campaignDate: colCampaignDate,
                                            campaignName: campaignName,
                                            projectId: projectId,
                                            projectName: await Utils.getProjectNameSlug({
                                                langId: colLang,
                                                project_type_slug: projectTypeSlug,
                                                project_slug: projectSlug
                                            }),
                                            url: url,
                                            projectSlug: projectSlug,
                                            status: status,
                                            statusLang : statusLang,
                                            statusProjectCode : statusProjectCode,
                                            statusProjectType : statusProjectType,
                                            statusCampaignDate : statusCampaignDate,
                                            statusCampaignId : statusCampaignId,
                                            apStatus: message.join(', ')
                                        });
                                    }
                                    else {
                                        projectListError.push({
                                            lang: colLang,
                                            projectType: colProjectType,
                                            projectCode: colProjectCode,
                                            campaignId: colCampaignId,
                                            campaignDate: colCampaignDate,
                                            campaignName: campaignName,
                                            projectId: projectId,
                                            projectName: '',
                                            url: url,
                                            projectSlug: projectSlug,
                                            status: status,
                                            statusLang : statusLang,
                                            statusProjectCode : statusProjectCode,
                                            statusProjectType : statusProjectType,
                                            statusCampaignDate : statusCampaignDate,
                                            statusCampaignId : statusCampaignId,
                                            apStatus: message.join(', ')
                                        });
                                    }
                                    message = [];
                                    statusAll.push(status);
                                }
                            }
                            setUploading(false);
                            setUploaded(true);
                            setExcelAlwaysOnPreview(projectList);
                            setExcelAlwaysOnPreviewError(projectListError);
                            if(projectList && projectList.length > 0) {
                                if(statusAll.includes(2) || statusAll.includes(0)) {
                                    setDisableImport(true);
                                }
                                else {
                                    setDisableImport(false);
                                }
                                toast.success("Generate Result เรียบร้อย");
                            }
                            else {
                                toast.error("Generate ไม่สำเร็จ กรุณาตรวจสอบข้อมูลใน Excel อีกครั้ง");
                            }
                        }
                    }
                    else if(typeId.id === Utils.ADSNAMING_GROUP_ADHOC_CAMPAIGN) {
                        let cols = header.split(',');
                        if(cols[0] !== 'Lang') {
                            setUploading(false);
                            toast.error("Column 1 : ต้องเป็น(ชื่อ) Lang");
                            return;
                        }
                        else if(cols[1] !== 'BU Type') {
                            setUploading(false);
                            toast.error("Column 2 : ต้องเป็น(ชื่อ) BU Type");
                            return;
                        }
                        else if(cols[2] !== 'Campaign Type') {
                            setUploading(false);
                            toast.error("Column 3 : ต้องเป็น(ชื่อ) Campaign Type");
                            return;
                        }
                        else if(cols[3] !== 'Campaign ID') {
                            setUploading(false);
                            toast.error("Column 4 : ต้องเป็น(ชื่อ) Campaign ID");
                            return;
                        }
                        else if(cols[4] !== 'Campaign Date') {
                            setUploading(false);
                            toast.error("Column 5 : ต้องเป็น(ชื่อ) Campaign Date");
                            return;
                        }

                        if(row.length > 0) {
                            let message = [];
                            let statusAll = [];
                            let promotionList = [];
                            let promotionListError = [];

                            for(let i=1;i<row.length;i++) {
                                let cols = row[i].split(',');
                                let colLang = cols[0].toString().trim();
                                let colButype = cols[1].toString().trim();
                                let colCampaignType = cols[2].toString().trim();
                                let colCampaignId = cols[3].toString().trim();
                                let colCampaignDate = Utils.dateFromExcel(cols[4].toString().trim());

                                let status = 0;
                                if(colLang && colButype && colCampaignType && colCampaignId) {

                                    let statusLang = true;
                                    if(langIds && !langIds.includes(colLang)) {
                                        status = 2;
                                        statusLang = false;
                                        message.push('Invalid Lang');
                                    }
                                    else {
                                        statusLang = true;
                                    }

                                    let statusCampaignType = true;
                                    if(colCampaignType === Utils.CAMPAIGN_TYPE_ALL || colCampaignType === Utils.CAMPAIGN_TYPE_SPECIAL) {
                                        statusCampaignType = true;
                                    }
                                    else {
                                        status = 2;
                                        statusCampaignType = false;
                                        message.push('Invalid Campaign Type');
                                    }

                                    let statusBuType = true;
                                    if(colButype === 'condo' || colButype === 'condominium') {
                                        colButype = 'condo1,condo2';
                                    }
                                    if(buTypeIds && !buTypeIds.includes(colButype)) {
                                        status = 2;
                                        statusBuType = false;
                                        message.push('Invalid BU Type');
                                    }
                                    else {
                                        statusBuType = true;
                                    }

                                    let statusCampaignDate = true;
                                    let statusCampaignId = true;
                                    let url = '';
                                    let promotionSlug = '';
                                    let campaignName = '';
                                    let campaignIdArr = [];

                                    if(!colCampaignDate) {
                                        status = 2;
                                        statusCampaignDate = false;
                                        message.push('Invalid campaign date');
                                    }
                                    else if(statusLang && statusBuType && statusCampaignType) {
                                        statusCampaignDate = true;
                                        const promotionResult = await getPromotion(colLang, colCampaignType, colButype, colCampaignDate);
                                        if(promotionResult && promotionResult.data.length > 0) {
                                            for(let rs of promotionResult.data) {
                                                if(colCampaignId === '0638A01') {
                                                    status = 1;
                                                    break;
                                                }
                                                else {
                                                    if(rs.campaign_id === colCampaignId) {
                                                        url = rs.promotion_url;
                                                        promotionSlug = rs.promotion_slug;
                                                        campaignName = rs.campaign_name;
                                                        if(url) {
                                                            status = 1;
                                                            break;
                                                        }
                                                        else {
                                                            status = 2;
                                                            message.push(promotionResult.message);
                                                        }
                                                    }
                                                    else {
                                                        campaignIdArr.push(2);
                                                    }
                                                }
                                            }
                                        }
                                        else {
                                            status = 2;
                                            message.push(promotionResult.message);
                                        }
                                    }

                                    if(status === 1) {
                                        campaignIdArr = [];
                                    }

                                    if(campaignIdArr.length > 0) {
                                        statusCampaignId = false;
                                        status = 2;
                                        message.push('Campaign ID not found');
                                    }

                                    campaignIdArr = [];
                                    if(status === 1) {
                                        promotionList.push({
                                            lang: colLang,
                                            buType: colButype,
                                            campaignType: colCampaignType,
                                            campaignId: colCampaignId,
                                            campaignDate: colCampaignDate,
                                            campaignName: campaignName,
                                            url: url,
                                            promotionSlug: await Utils.getPromotionSlug({
                                                buTypeId: colButype,
                                                campaignTypeId: colCampaignType,
                                                langId: colLang,
                                                promotionSlug: promotionSlug
                                            }),
                                            status: status,
                                            statusLang : statusLang,
                                            statusBuType : statusBuType,
                                            statusCampaignType : statusCampaignType,
                                            statusCampaignDate : statusCampaignDate,
                                            statusCampaignId : statusCampaignId,
                                            apStatus: message.join(', ')
                                        });
                                    }
                                    else {
                                        promotionListError.push({
                                            lang: colLang,
                                            buType: colButype,
                                            campaignType: colCampaignType,
                                            campaignId: colCampaignId,
                                            campaignDate: colCampaignDate,
                                            campaignName: campaignName,
                                            url: url,
                                            promotionSlug: '',
                                            status: status,
                                            statusLang : statusLang,
                                            statusBuType : statusBuType,
                                            statusCampaignType : statusCampaignType,
                                            statusCampaignDate : statusCampaignDate,
                                            statusCampaignId : statusCampaignId,
                                            apStatus: message.join(', ')
                                        });
                                    }
                                    message = [];
                                    statusAll.push(status);
                                }
                            }
                            setUploading(false);
                            setUploaded(true);
                            setExcelAdHocPreview(promotionList);
                            setExcelAdHocPreviewError(promotionListError);
                            if(promotionList && promotionList.length > 0) {
                                if (statusAll && statusAll.includes(2) || statusAll.includes(0)) {
                                    setDisableImport(true);
                                } else {
                                    setDisableImport(false);
                                }
                                toast.success("Generate Result เรียบร้อย");
                            }
                            else {
                                toast.error("Generate ไม่สำเร็จ กรุณาตรวจสอบข้อมูลใน Excel อีกครั้ง");
                            }
                        }
                    }
                    else if(typeId.id === Utils.ADSNAMING_GROUP_SPECIAL) {
                        if(isCustomUrl) {
                            await uploadCustomURL();
                        }
                        else {
                            if(specialFilterId) {
                                if(specialFilterId.id === Utils.ADS_NAMING_SPECIAL_FILTER_BG_ZONE) {
                                    await uploadBgZone();
                                }
                                else if(specialFilterId.id === Utils.ADS_NAMING_SPECIAL_FILTER_COMBINE_ZONE) {
                                    await uploadCombineZone();
                                }
                                else if(specialFilterId.id === Utils.ADS_NAMING_SPECIAL_FILTER_EVENT_REMINDER) {
                                    await uploadEventReminder();
                                }
                                else if(specialFilterId.id === Utils.ADS_NAMING_SPECIAL_FILTER_STATIC_PAGE) {
                                    await uploadStaticPage();
                                }
                            }
                            else {
                                toast.error("กรุณาระบุ Filter Type");
                            }
                        }
                    }
                }
            };
            reader.readAsBinaryString(file);
        }
    };

    const onGenerateUTM = () => {
        confirmAlert({
            title: 'แจ้งเตือน',
            message: 'ต้องการบันทึกข้อมูล ?',
            buttons: [
                {
                    label: 'ตกลง',
                    onClick: async () => {
                        let jsonData = [];
                        let typeName = '';
                        let bulkBody = [];
                        setImporting(true);
                        if(typeId.id === Utils.ADSNAMING_GROUP_ALWAYS_ON) {
                            typeName = 'AlwaysOn';
                            let n = 0;
                            for(let rs of showExcelAlwaysOnPreview) {
                                let utmData = [];
                                for(let pm of sourceTypeAllIds) {
                                    let params = pm.params;
                                    let adsPlatformId = pm.adsPlatformId;
                                    let adsNamingSetNameTypeId = pm.adsNamingSetNameTypeId;
                                    let itemSource = pm.itemSource;
                                    //let sourceTypeIdsTmp = [];
                                    let sourceTypeIds = [];
                                    //for(let p of params) {
                                    //    sourceTypeIdsTmp.push(p);
                                    //}
                                    for(let is of itemSource) {
                                        let text = is.text;
                                        if(is.inputType === Utils.ADSNAMING_TYPE_SLUG_PROJECT) {
                                            text = rs.projectSlug;
                                        }
                                        sourceTypeIds.push({
                                            adsNamingSourceId: is.adsNamingSourceId,
                                            adsNamingId: is.id,
                                            text: text,
                                            inputType: is.inputType
                                        });
                                    }

                                    //get agency
                                    let param = previewParams[n].params;

                                    //let param = await getParams(sourceTypeIdsTmp, adsNamingSetNameTypeId);
                                    param = param.replace('{projectCode}', rs.projectId);
                                    param = param.replace('{slugProject}', rs.projectSlug);
                                    param = param.replace('{campaignId}', rs.campaignId);

                                    bulkBody.push({
                                        lang: rs.lang ?? null,
                                        typeId: typeId.id ?? null,
                                        projectTypeId: rs.projectType ?? null,
                                        projectCode: rs.projectId ?? null,
                                        campaignDate: rs.campaignDate ? new Date(rs.campaignDate) : null,
                                        adsPlatformId: adsPlatformId,
                                        projectId: rs.projectId ?? null,
                                        campaignId: rs.campaignId ?? null,
                                        adsNamingSetNameTypeId: adsNamingSetNameTypeId,
                                        params: param,
                                        createdBy: userId,
                                        createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                        updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                        sourceTypeIds: sourceTypeIds
                                    });

                                    jsonData.push({
                                        typeId: Utils.ADSNAMING_GROUP_ALWAYS_ON,
                                        row: rs,
                                        utm: utmData,
                                        params: param
                                    });
                                    n++;
                                    if(n === previewParams.length) {
                                        n = 0;
                                    }
                                }
                            }
                            insertToDB(bulkBody, jsonData, typeName);
                        }
                        else if(typeId.id === Utils.ADSNAMING_GROUP_ADHOC_CAMPAIGN) {
                            typeName = 'AdHoc';
                            let n = 0;
                            for(let rs of showExcelAdHocPreview) {
                                let utmData = [];
                                for(let pm of sourceTypeAllIds) {
                                    let params = pm.params;
                                    let adsPlatformId = pm.adsPlatformId;
                                    let adsNamingSetNameTypeId = pm.adsNamingSetNameTypeId;
                                    let itemSource = pm.itemSource;
                                    //let sourceTypeIdsTmp = [];
                                    let sourceTypeIds = [];
                                    //for(let p of params) {
                                    //    sourceTypeIdsTmp.push(p);
                                    //}
                                    for(let is of itemSource) {
                                        let text = is.text;
                                        if(is.inputType === Utils.ADSNAMING_TYPE_SLUG_PROMOTION) {
                                            text = rs.promotionSlug;
                                        }
                                        sourceTypeIds.push({
                                            adsNamingSourceId: is.adsNamingSourceId,
                                            adsNamingId: is.id,
                                            text: text,
                                            inputType: is.inputType
                                        });
                                    }

                                    //get agency
                                    let param = previewParams[n].params;

                                    //let param = await getParams(sourceTypeIdsTmp, adsNamingSetNameTypeId);
                                    param = param.replace('{slugPromotion}', rs.promotionSlug);
                                    param = param.replace('{campaignId}', rs.campaignId);

                                    bulkBody.push({
                                        typeId: typeId.id,
                                        lang: rs.lang ?? null,
                                        projectTypeId: rs.projectType ?? null,
                                        projectId: rs.projectCode ?? null,
                                        projectCode: rs.projectCode ?? null,
                                        campaignDate: rs.campaignDate ? new Date(rs.campaignDate) : null,
                                        adsPlatformId: adsPlatformId,
                                        adsNamingSetNameTypeId: adsNamingSetNameTypeId,
                                        campaignId: rs.campaignId ?? null,
                                        campaignTypeId: rs.campaignType ?? null,
                                        buTypeId: rs.buType ?? null,
                                        params: param,
                                        createdBy: userId,
                                        createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                        updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                        sourceTypeIds: sourceTypeIds
                                    });

                                    jsonData.push({
                                        typeId: Utils.ADSNAMING_GROUP_ADHOC_CAMPAIGN,
                                        row: rs,
                                        utm: utmData,
                                        params: param
                                    });
                                    n++;
                                    if(n === previewParams.length) {
                                        n = 0;
                                    }
                                }
                            }
                            insertToDB(bulkBody, jsonData, typeName);
                        }
                        else if(typeId.id === Utils.ADSNAMING_GROUP_SPECIAL) {
                            typeName = 'Special';
                            let n = 0;
                            for(let rs of showExcelSpecialPreview) {
                                let utmData = [];
                                for(let pm of sourceTypeAllIds) {
                                    let params = pm.params;
                                    let agencyId = pm.agencyId;
                                    let adsPlatformId = pm.adsPlatformId;
                                    let adsNamingSetNameTypeId = pm.adsNamingSetNameTypeId;
                                    let itemSource = pm.itemSource;
                                    let sourceTypeIds = [];
                                    for(let is of itemSource) {
                                        let text = is.text;
                                        if(is.inputType === Utils.ADSNAMING_TYPE_SLUG_SPECIAL) {
                                            text = rs.apData.slug;
                                        }
                                        sourceTypeIds.push({
                                            adsNamingSourceId: is.adsNamingSourceId,
                                            adsNamingId: is.adsNamingId,
                                            text: text,
                                            inputType: is.inputType
                                        });
                                    }

                                    //get agency
                                    let param = previewParams[n].params;
                                    param = param.replace('{slugSpecial}', rs.apData.slug);
                                    param = param.replace('{campaignId}', rs.campaignId?.data);

                                    bulkBody.push({
                                        specialFilterId: specialFilterId ? specialFilterId.id:null,
                                        projectTypeId: rs.zoneProject?.data ?? null,
                                        zoneStatus: rs.zoneStatus?.data ?? null,
                                        eventDate: rs.eventDate?.data ?? null,
                                        webPage: rs.webPage?.data ?? null,
                                        adsPlatformId: adsPlatformId ?? null,
                                        isCustomUrl: isCustomUrl ? 1:null,
                                        lang: rs.lang?.data ?? null,
                                        typeId: typeId.id,
                                        projectCode: null,
                                        campaignDate: null,
                                        adsNamingSetNameTypeId: adsNamingSetNameTypeId ?? null,
                                        params: param,
                                        createdBy: userId,
                                        createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                        updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                        sourceTypeIds: sourceTypeIds
                                    });

                                    jsonData.push({
                                        typeId: Utils.ADSNAMING_GROUP_SPECIAL,
                                        row: rs,
                                        utm: utmData,
                                        params: param
                                    });
                                    n++;
                                    if(n === previewParams.length) {
                                        n = 0;
                                    }
                                }
                            }
                            insertToDB(bulkBody, jsonData, typeName);
                        }
                    }
                },
                {
                    label: 'ยกเลิก',
                    onClick: () => {}
                }
            ]
        });
    };

    const insertToDB = (body, jsonData, typeName) => {
        fetch(Config.url.API_URL +'/api/adsNamingSetName/createBulks', {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                'Content-Type':'application/json',
                'x-access-token': roles.accessToken
            }
        }).then(response => {
            if(response.ok) {
                return response.json();
            }
            else {
                return response.json().then(err => Promise.reject(err));
            }
        }).then(result => {
            if(result) {
                if(jsonData) {
                    let newJsonData = [];
                    if(jsonData[0].typeId === Utils.ADSNAMING_GROUP_ALWAYS_ON) {
                        let jsonLength = jsonData.length;
                        for(let i=0;i<jsonLength;i++) {
                            let item = [];
                            item['Lang'] = jsonData[i].row.lang;
                            item['ProjectType'] = jsonData[i].row.projectType;
                            item['ProjectCode'] = jsonData[i].row.projectCode;
                            item['CampaignID'] = jsonData[i].row.campaignId;
                            item['CampaignDate'] = jsonData[i].row.campaignDate;
                            item['Params'] = jsonData[i].params;
                            newJsonData.push(item);
                        }
                    }
                    if(jsonData[0].typeId === Utils.ADSNAMING_GROUP_ADHOC_CAMPAIGN) {
                        let jsonLength = jsonData.length;
                        for(let i=0;i<jsonLength;i++) {
                            let item = [];
                            item['Lang'] = jsonData[i].row.lang;
                            item['BUType'] = jsonData[i].row.buType;
                            item['CampaignType'] = jsonData[i].row.campaignType;
                            item['CampaignID'] = jsonData[i].row.campaignId;
                            item['CampaignDate'] = jsonData[i].row.campaignDate;
                            item['Params'] = jsonData[i].params;
                            newJsonData.push(item);
                        }
                    }
                    const worksheet = XLSX.utils.json_to_sheet(newJsonData);
                    const workbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
                    XLSX.writeFile(workbook, "AdsSetnameData_" + typeName + "_" + Utils.getDate() + ".xlsx");
                }

                toast.success("บันทึกข้อมูลเรียบร้อย");
                setImporting(false);
                setTimeout(function () {
                    window.location = '/adsNamingSetName';
                    //navigate('/adsNamingSetName', {replace: true});
                }, 1500);
            }
        }).catch(err => {
            toast.error(err.message);
        })
    };

    const resetUpload = () => {
        window.location.reload();
    };

    async function getParams(sourceTypeTextParam, adsNamingSetNameTypeId, adsPlatformId) {
        let textParams = [];
        if(sourceTypeTextParam) {
            for(let text of sourceTypeTextParam) {
                if(text) {
                    textParams.push(text);
                }
            }
        }

        //Fixed BG
        let bg = textParams.length > 0 ? textParams[0]:'';

        //Fixed Slug
        let slug = textParams.length > 1 ? textParams[1]:'';

        //After that
        let textParamsNew = [];
        let xLength = textParams.length;
        if(textParams.length > 2) {
            for(let i=2;i<xLength;i++) {
                if(textParams[i].length > 0) {
                    textParamsNew.push(textParams[i]);
                }
            }
        }

        let adsNamingSetNameTypeName = '';
        if(adsNamingSetNameTypeId) {
            const rs = await Utils.getAdsNamingSetNameTypeView(adsNamingSetNameTypeId);
            adsNamingSetNameTypeName = rs.name;
        }

        let platformName = '';
        if(platform && adsPlatformId) {
            platformName = '_' + platform.filter(e => e.id === adsPlatformId)[0].name;
        }

        let param = '';
        if(typeId.id === Utils.ADSNAMING_GROUP_ALWAYS_ON) {
            param = bg + '_' + slug + '|' + textParamsNew.join('_') + platformName + '|' + adsNamingSetNameTypeName + '_[ST]';
        }
        else if(typeId.id === Utils.ADSNAMING_GROUP_ADHOC_CAMPAIGN) {
            param = bg + '_' + slug + '|' + textParamsNew.join('_') + platformName + '|' + adsNamingSetNameTypeName + '_[ST]';
        }
        else if(typeId.id === Utils.ADSNAMING_GROUP_SPECIAL) {
            param = bg + '_' + slug + '|' + textParamsNew.join('_') + platformName + '|' + adsNamingSetNameTypeName + '_[ST]';
        }
        return param;
    }

    const onChangeCustomUrl = async (flag) => {
        setIsCustomUrl(flag);
    };

    const onChangeFilterTypeId = async (obj) => {
        setSpecialFilterId(obj);
    };

    async function uploadCustomURL() {
        if (excelFile && excelFile.target.value) {

            if (!excelFile || typeof excelFile.target === 'undefined') {
                toast.error("กรุณาระบุ Excel File");
            }
            else {
                setUploading(true);

                const [file] = excelFile.target.files;
                const reader = new FileReader();

                reader.onload = async (evt) => {
                    const bstr = evt.target.result;
                    const wb = XLSX.read(bstr, {type: "binary"});
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];
                    const data = XLSX.utils.sheet_to_csv(ws, {header: 1});

                    if(data) {
                        let row = data.split('\n');
                        let header = row[0];
                        let cols = header.split(',');
                        if(cols[0] !== 'URL') {
                            setUploading(false);
                            toast.error("Column 1 : ต้องเป็น(ชื่อ) URL");
                        }
                        else if(cols[1] !== 'Slug') {
                            setUploading(false);
                            toast.error("Column 2 : ต้องเป็น(ชื่อ) Slug");
                        }
                        else if(cols[2] !== 'Campaign ID') {
                            setUploading(false);
                            toast.error("Column 4 : ต้องเป็น(ชื่อ) Campaign ID");
                        }
                        else {
                            let excelArrAll = [];
                            let excelArrError = [];
                            let statusError = [];
                            for(let i=1;i<row.length;i++) {
                                let cols = row[i].split(',');
                                let colUrl = cols[0].toString().trim();
                                let colSlug = cols[1].toString().trim();
                                let colCampaignId = cols[2].toString().trim();

                                let message = [];

                                //-------------------------------

                                let statusUrl = false;
                                if(!colUrl) {
                                    message.push('Please input URL');
                                }
                                else {
                                    statusUrl = true;
                                }
                                statusError.push(statusUrl);

                                //-------------------------------

                                let statusSlug = false;
                                if(!colSlug) {
                                    message.push('Please input Slug');
                                }
                                else {
                                    statusSlug = true;
                                }
                                statusError.push(statusSlug);

                                //-------------------------------

                                let statusCampaignId = false;
                                let campaignName = '';
                                if(colUrl && colSlug) {
                                    if(colCampaignId === '0638A01') {
                                        statusCampaignId = true;
                                        campaignName = 'NonDefine';
                                    }
                                    else {
                                        const resCampaign = await Utils.getListSubCampaignImport();
                                        if (resCampaign.statusCode === 200 || resCampaign.campaign) {
                                            if (resCampaign.campaign && resCampaign.campaign.length > 0) {
                                                let campaignList = resCampaign.campaign;
                                                let campaignRow = campaignList.filter(e => e.sub_campaign_id === colCampaignId)[0];
                                                if (campaignRow && campaignRow.sub_campaign_id) {
                                                    statusCampaignId = true;
                                                    campaignName = campaignRow.sub_campaign_name;
                                                } else {
                                                    statusCampaignId = false;
                                                    message.push('Invalid Campaign ID');
                                                }
                                            } else {
                                                message.push('API /api/cm/listsubcampaign : Not found data');
                                            }
                                        } else {
                                            message.push('API /api/cm/listsubcampaign : statusCode: ' + resCampaign.statusCode + ', message: ' + resCampaign.message);
                                        }
                                    }
                                }
                                statusError.push(statusCampaignId);

                                //-------------------------------

                                if(!statusUrl || !statusSlug || !statusCampaignId) {
                                    excelArrError.push({
                                        lang: {
                                            data: 'th',
                                            status: true,
                                        },
                                        campaignId: {
                                            data: colCampaignId,
                                            status: statusCampaignId
                                        },
                                        campaignName: {
                                            data: campaignName
                                        },
                                        apData: {
                                            url : colUrl,
                                            slug: colSlug,
                                            status: statusUrl && statusSlug,
                                            message: message
                                        }
                                    });
                                }

                                excelArrAll.push({
                                    lang: {
                                        data: 'th',
                                        status: true,
                                    },
                                    campaignId: {
                                        data: colCampaignId,
                                        status: statusCampaignId
                                    },
                                    campaignName: {
                                        data: campaignName
                                    },
                                    apData: {
                                        url : colUrl,
                                        slug: colSlug,
                                        status: statusUrl && statusSlug,
                                        message: message
                                    }
                                });
                            }

                            setExcelSpecialPreview(excelArrAll);
                            setExcelSpecialPreviewError(excelArrError);
                            if(excelArrAll && excelArrAll.length > 0) {
                                if(excelArrError && excelArrError.length > 0) {
                                    setDisableImport(true);
                                }
                                else {
                                    setDisableImport(false);
                                }
                                toast.success("Generate Result เรียบร้อย");
                            }
                            else {
                                toast.error("Generate ไม่สำเร็จ กรุณาตรวจสอบข้อมูลใน Excel อีกครั้ง");
                            }
                        }
                    }
                    setUploading(false);
                    setUploaded(true);
                };
                reader.readAsBinaryString(file);
            }

        } else {
            toast.error("กรุณาระบุ Excel File");
        }
    }

    async function uploadBgZone() {
        if (excelFile && excelFile.target.value) {

            if (!excelFile || typeof excelFile.target === 'undefined') {
                toast.error("กรุณาระบุ Excel File");
            }
            else {
                setUploading(true);

                const [file] = excelFile.target.files;
                const reader = new FileReader();

                reader.onload = async (evt) => {
                    const bstr = evt.target.result;
                    const wb = XLSX.read(bstr, {type: "binary"});
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];
                    const data = XLSX.utils.sheet_to_csv(ws, {header: 1});

                    if(data) {
                        let row = data.split('\n');
                        let header = row[0];
                        let cols = header.split(',');
                        if(cols[0] !== 'Lang') {
                            setUploading(false);
                            toast.error("Column 1 : ต้องเป็น(ชื่อ) Lang");
                        }
                        else if(cols[1] !== 'Zone Project') {
                            setUploading(false);
                            toast.error("Column 2 : ต้องเป็น(ชื่อ) Zone Project");
                        }
                        else if(cols[2] !== 'Zone Status') {
                            setUploading(false);
                            toast.error("Column 3 : ต้องเป็น(ชื่อ) Zone Status");
                        }
                        else if(cols[3] !== 'Slug') {
                            setUploading(false);
                            toast.error("Column 4 : ต้องเป็น(ชื่อ) Slug");
                        }
                        else if(cols[4] !== 'Campaign ID') {
                            setUploading(false);
                            toast.error("Column 5 : ต้องเป็น(ชื่อ) Campaign ID");
                        }
                        else {
                            let excelArrAll = [];
                            let excelArrError = [];
                            let statusError = [];
                            for(let i=1;i<row.length;i++) {
                                let cols = row[i].split(',');
                                let colUrl = null;
                                let colLang = cols[0].toString().trim();
                                let colZoneProject = cols[1].toString().trim();
                                let colZoneStatus = cols[2].toString().trim();
                                let colSlug = cols[3].toString().trim();
                                let colCampaignId = cols[4].toString().trim();

                                let message = [];

                                //-------------------------------

                                let statusLang = false;
                                if(lang) {
                                    statusLang = lang.filter(e => e.id === colLang).length > 0;
                                }
                                if(!colLang) {
                                    message.push('Please input Lang');
                                }
                                if(!statusLang) {
                                    message.push('Invalid Lang');
                                }
                                statusError.push(statusLang);

                                //-------------------------------

                                let statusZoneProject = false;
                                if(projectType) {
                                    statusZoneProject = projectType.filter(e => e.id === colZoneProject).length > 0;
                                }
                                if(!colZoneProject) {
                                    message.push('Please input Zone Project');
                                }
                                if(!statusZoneProject) {
                                    message.push('Invalid Zone Project');
                                }
                                statusError.push(statusZoneProject);

                                //-------------------------------

                                let statusZoneStatus = false;
                                if(zoneStatus) {
                                    statusZoneStatus = zoneStatus.filter(e => e.id === colZoneStatus).length > 0;
                                }
                                if(!colZoneStatus) {
                                    message.push('Please input Zone Status');
                                }
                                if(!statusZoneStatus) {
                                    message.push('Invalid Zone Status');
                                }
                                statusError.push(statusZoneStatus);

                                //-------------------------------

                                let statusSlug = false;
                                if(!colSlug) {
                                    message.push('Please input Slug');
                                }
                                else {
                                    if(colLang && colZoneProject && colZoneStatus) {
                                        const resBGZone = await Utils.getBGZoneImport({
                                            langId: colLang,
                                            projectTypeId: colZoneProject,
                                            zoneStatusId: colZoneStatus
                                        });
                                        let checkSlug = resBGZone.data.zones.filter(e => e.zone_slug === colSlug);
                                        if(checkSlug) {
                                            statusSlug = checkSlug.length > 0;
                                            if(statusSlug) {
                                                colUrl = checkSlug[0].zone_url;
                                            }
                                        }
                                    }
                                    if(!statusSlug) {
                                        message.push('Invalid Slug');
                                    }
                                }
                                statusError.push(statusSlug);

                                //-------------------------------

                                let statusCampaignId = false;
                                let campaignName = '';
                                if(colUrl && colSlug) {
                                    if(colCampaignId === '0638A01') {
                                        statusCampaignId = true;
                                        campaignName = 'NonDefine';
                                    }
                                    else {
                                        const resCampaign = await Utils.getListSubCampaignImport();
                                        if (resCampaign.statusCode === 200 || resCampaign.message === 'success') {
                                            if (resCampaign.campaign && resCampaign.campaign.length > 0) {
                                                let campaignList = resCampaign.campaign;
                                                let campaignRow = campaignList.filter(e => e.sub_campaign_id === colCampaignId)[0];
                                                if (campaignRow && campaignRow.sub_campaign_id) {
                                                    statusCampaignId = true;
                                                    campaignName = campaignRow.sub_campaign_name;
                                                } else {
                                                    statusCampaignId = false;
                                                    message.push('Invalid Campaign ID');
                                                }
                                            } else {
                                                message.push('API /api/cm/listsubcampaign : Not found data');
                                            }
                                        } else {
                                            message.push('API /api/cm/listsubcampaign : statusCode: ' + resCampaign.statusCode + ', message: ' + resCampaign.message);
                                        }
                                    }
                                }
                                statusError.push(statusCampaignId);

                                //-------------------------------

                                if(!statusLang || !statusZoneProject || !statusZoneStatus || !statusSlug || !statusCampaignId) {
                                    excelArrError.push({
                                        lang: {
                                            data: colLang,
                                            status: statusLang,
                                        },
                                        zoneProject: {
                                            data: colZoneProject,
                                            status: statusZoneProject,
                                        },
                                        zoneStatus: {
                                            data: colZoneStatus,
                                            status: statusZoneStatus,
                                        },
                                        campaignId: {
                                            data: colCampaignId,
                                            status: statusCampaignId
                                        },
                                        campaignName: {
                                            data: campaignName
                                        },
                                        apData: {
                                            url : colUrl,
                                            slug: colSlug,
                                            status: statusSlug,
                                            message: message
                                        }
                                    });
                                }

                                excelArrAll.push({
                                    lang: {
                                        data: colLang,
                                        status: statusLang,
                                    },
                                    zoneProject: {
                                        data: colZoneProject,
                                        status: statusZoneProject,
                                    },
                                    zoneStatus: {
                                        data: colZoneStatus,
                                        status: statusZoneStatus,
                                    },
                                    campaignId: {
                                        data: colCampaignId,
                                        status: statusCampaignId
                                    },
                                    campaignName: {
                                        data: campaignName
                                    },
                                    apData: {
                                        url : colUrl,
                                        slug: colSlug,
                                        status: statusSlug,
                                        message: message
                                    }
                                });
                            }

                            setExcelSpecialPreview(excelArrAll);
                            setExcelSpecialPreviewError(excelArrError);
                            if(excelArrAll && excelArrAll.length > 0) {
                                if(excelArrError && excelArrError.length > 0) {
                                    setDisableImport(true);
                                }
                                else {
                                    setDisableImport(false);
                                }
                                toast.success("Generate Result เรียบร้อย");
                            }
                            else {
                                toast.error("Generate ไม่สำเร็จ กรุณาตรวจสอบข้อมูลใน Excel อีกครั้ง");
                            }
                        }
                    }
                    setUploading(false);
                    setUploaded(true);
                };
                reader.readAsBinaryString(file);
            }

        } else {
            toast.error("กรุณาระบุ Excel File");
        }
    }

    async function uploadCombineZone() {
        if (excelFile && excelFile.target.value) {

            if (!excelFile || typeof excelFile.target === 'undefined') {
                toast.error("กรุณาระบุ Excel File");
            }
            else {
                setUploading(true);

                const [file] = excelFile.target.files;
                const reader = new FileReader();

                reader.onload = async (evt) => {
                    const bstr = evt.target.result;
                    const wb = XLSX.read(bstr, {type: "binary"});
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];
                    const data = XLSX.utils.sheet_to_csv(ws, {header: 1});

                    if(data) {
                        let row = data.split('\n');
                        let header = row[0];
                        let cols = header.split(',');
                        if(cols[0] !== 'Lang') {
                            setUploading(false);
                            toast.error("Column 1 : ต้องเป็น(ชื่อ) Lang");
                        }
                        else if(cols[1] !== 'Zone Status') {
                            setUploading(false);
                            toast.error("Column 2 : ต้องเป็น(ชื่อ) Zone Status");
                        }
                        else if(cols[2] !== 'Slug') {
                            setUploading(false);
                            toast.error("Column 3 : ต้องเป็น(ชื่อ) Slug");
                        }
                        else if(cols[3] !== 'Campaign ID') {
                            setUploading(false);
                            toast.error("Column 4 : ต้องเป็น(ชื่อ) Campaign ID");
                        }
                        else {
                            let excelArrAll = [];
                            let excelArrError = [];
                            let statusError = [];
                            for(let i=1;i<row.length;i++) {
                                let cols = row[i].split(',');
                                let colUrl = null;
                                let colLang = cols[0].toString().trim();
                                let colZoneStatus = cols[1].toString().trim();
                                let colSlug = cols[2].toString().trim();
                                let colCampaignId = cols[3].toString().trim();

                                let message = [];

                                //-------------------------------

                                let statusLang = false;
                                if(lang) {
                                    statusLang = lang.filter(e => e.id === colLang).length > 0;
                                }
                                if(!colLang) {
                                    message.push('Please input Lang');
                                }
                                if(!statusLang) {
                                    message.push('Invalid Lang');
                                }
                                statusError.push(statusLang);

                                //-------------------------------

                                let statusZoneStatus = false;
                                if(zoneStatus) {
                                    statusZoneStatus = zoneStatus.filter(e => e.id === colZoneStatus).length > 0;
                                }
                                if(!colZoneStatus) {
                                    message.push('Please input Zone Status');
                                }
                                if(!statusZoneStatus) {
                                    message.push('Invalid Zone Status');
                                }
                                statusError.push(statusZoneStatus);

                                //-------------------------------

                                let statusSlug = false;
                                if(!colSlug) {
                                    message.push('Please input Slug');
                                }
                                else {
                                    if(colLang && colZoneStatus) {
                                        const resBGZone = await Utils.getCombineZoneImport({
                                            langId: colLang,
                                            zoneStatusId: colZoneStatus
                                        });
                                        let checkSlug = resBGZone.data.zones.filter(e => e.zone_slug === colSlug);
                                        if(checkSlug) {
                                            statusSlug = checkSlug.length > 0;
                                            if(statusSlug) {
                                                colUrl = checkSlug[0].zone_url;
                                            }
                                        }
                                    }
                                    if(!statusSlug) {
                                        message.push('Invalid Slug');
                                    }
                                }
                                statusError.push(statusSlug);

                                //-------------------------------

                                let statusCampaignId = false;
                                let campaignName = '';
                                if(colUrl && colSlug) {
                                    if(colCampaignId === '0638A01') {
                                        statusCampaignId = true;
                                        campaignName = 'NonDefine';
                                    }
                                    else {
                                        const resCampaign = await Utils.getListSubCampaignImport();
                                        if (resCampaign.statusCode === 200 || resCampaign.message === 'success') {
                                            if (resCampaign.campaign && resCampaign.campaign.length > 0) {
                                                let campaignList = resCampaign.campaign;
                                                let campaignRow = campaignList.filter(e => e.sub_campaign_id === colCampaignId)[0];
                                                if (campaignRow && campaignRow.sub_campaign_id) {
                                                    statusCampaignId = true;
                                                    campaignName = campaignRow.sub_campaign_name;
                                                } else {
                                                    statusCampaignId = false;
                                                    message.push('Invalid Campaign ID');
                                                }
                                            } else {
                                                message.push('API /api/cm/listsubcampaign : Not found data');
                                            }
                                        } else {
                                            message.push('API /api/cm/listsubcampaign : statusCode: ' + resCampaign.statusCode + ', message: ' + resCampaign.message);
                                        }
                                    }
                                }
                                statusError.push(statusCampaignId);

                                //-------------------------------

                                if(!statusLang || !statusZoneStatus || !statusSlug || !statusCampaignId) {
                                    excelArrError.push({
                                        lang: {
                                            data: colLang,
                                            status: statusLang,
                                        },
                                        zoneStatus: {
                                            data: colZoneStatus,
                                            status: statusZoneStatus,
                                        },
                                        campaignId: {
                                            data: colCampaignId,
                                            status: statusCampaignId
                                        },
                                        campaignName: {
                                            data: campaignName
                                        },
                                        apData: {
                                            url : colUrl,
                                            slug: colSlug,
                                            status: statusSlug,
                                            message: message
                                        }
                                    });
                                }

                                excelArrAll.push({
                                    lang: {
                                        data: colLang,
                                        status: statusLang,
                                    },
                                    zoneStatus: {
                                        data: colZoneStatus,
                                        status: statusZoneStatus,
                                    },
                                    campaignId: {
                                        data: colCampaignId,
                                        status: statusCampaignId
                                    },
                                    campaignName: {
                                        data: campaignName
                                    },
                                    apData: {
                                        url : colUrl,
                                        slug: colSlug,
                                        status: statusSlug,
                                        message: message
                                    }
                                });
                            }

                            setExcelSpecialPreview(excelArrAll);
                            setExcelSpecialPreviewError(excelArrError);
                            if(excelArrAll && excelArrAll.length > 0) {
                                if(excelArrError && excelArrError.length > 0) {
                                    setDisableImport(true);
                                }
                                else {
                                    setDisableImport(false);
                                }
                                toast.success("Generate Result เรียบร้อย");
                            }
                            else {
                                toast.error("Generate ไม่สำเร็จ กรุณาตรวจสอบข้อมูลใน Excel อีกครั้ง");
                            }
                        }
                    }
                    setUploading(false);
                    setUploaded(true);
                };
                reader.readAsBinaryString(file);
            }

        } else {
            toast.error("กรุณาระบุ Excel File");
        }
    }

    async function uploadEventReminder() {
        if (excelFile && excelFile.target.value) {

            if (!excelFile || typeof excelFile.target === 'undefined') {
                toast.error("กรุณาระบุ Excel File");
            }
            else {
                setUploading(true);

                const [file] = excelFile.target.files;
                const reader = new FileReader();

                reader.onload = async (evt) => {
                    const bstr = evt.target.result;
                    const wb = XLSX.read(bstr, {type: "binary"});
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];
                    const data = XLSX.utils.sheet_to_csv(ws, {header: 1});

                    if(data) {
                        let row = data.split('\n');
                        let header = row[0];
                        let cols = header.split(',');
                        if(cols[0] !== 'Lang') {
                            setUploading(false);
                            toast.error("Column 1 : ต้องเป็น(ชื่อ) Lang");
                        }
                        else if(cols[1] !== 'Event Date') {
                            setUploading(false);
                            toast.error("Column 2 : ต้องเป็น(ชื่อ) Event Date");
                        }
                        else if(cols[2] !== 'Slug') {
                            setUploading(false);
                            toast.error("Column 3 : ต้องเป็น(ชื่อ) Slug");
                        }
                        else if(cols[3] !== 'Campaign ID') {
                            setUploading(false);
                            toast.error("Column 4 : ต้องเป็น(ชื่อ) Campaign ID");
                        }
                        else {
                            let excelArrAll = [];
                            let excelArrError = [];
                            let statusError = [];
                            for(let i=1;i<row.length;i++) {
                                let cols = row[i].split(',');
                                let colUrl = null;
                                let colLang = cols[0].toString().trim();
                                let colEventDate = cols[1].toString().trim();
                                let colSlug = cols[2].toString().trim();
                                let colCampaignId = cols[3].toString().trim();

                                let message = [];

                                //-------------------------------

                                let statusLang = false;
                                if(lang) {
                                    statusLang = lang.filter(e => e.id === colLang).length > 0;
                                }
                                if(!colLang) {
                                    message.push('Please input Lang');
                                }
                                if(!statusLang) {
                                    message.push('Invalid Lang');
                                }
                                statusError.push(statusLang);

                                //-------------------------------

                                let statusEventDate = true;
                                // if(colEventDate) {
                                //     statusEventDate = moment(colEventDate, 'YYYY-MM-DD').isValid();
                                //     if(!statusEventDate) {
                                //         message.push('Invalid Event Date');
                                //     }
                                // }
                                statusError.push(statusEventDate);

                                //-------------------------------

                                let statusSlug = false;
                                if(!colSlug) {
                                    message.push('Please input Slug');
                                }
                                else {
                                    if(colLang && colEventDate) {
                                        const resEventReminder= await Utils.getEventReminderImport({
                                            langId: colLang,
                                            eventDate: new Date(colEventDate)
                                        });
                                        let checkSlug = resEventReminder.data.filter(e => e.event_slug === colSlug);
                                        if(checkSlug) {
                                            statusSlug = checkSlug.length > 0;
                                            if(statusSlug) {
                                                colUrl = checkSlug[0].event_url;
                                            }
                                        }
                                    }
                                    if(!statusSlug) {
                                        message.push('Invalid Slug');
                                    }
                                }
                                statusError.push(statusSlug);

                                //-------------------------------

                                let statusCampaignId = false;
                                let campaignName = '';
                                if(colUrl && colSlug) {
                                    if(colCampaignId === '0638A01') {
                                        statusCampaignId = true;
                                        campaignName = 'NonDefine';
                                    }
                                    else {
                                        const resCampaign = await Utils.getListSubCampaignImport();
                                        if (resCampaign.statusCode === 200 || resCampaign.message === 'success') {
                                            if (resCampaign.campaign && resCampaign.campaign.length > 0) {
                                                let campaignList = resCampaign.campaign;
                                                let campaignRow = campaignList.filter(e => e.sub_campaign_id === colCampaignId)[0];
                                                if (campaignRow && campaignRow.sub_campaign_id) {
                                                    statusCampaignId = true;
                                                    campaignName = campaignRow.sub_campaign_name;
                                                } else {
                                                    statusCampaignId = false;
                                                    message.push('Invalid Campaign ID');
                                                }
                                            } else {
                                                message.push('API /api/cm/listsubcampaign : Not found data');
                                            }
                                        } else {
                                            message.push('API /api/cm/listsubcampaign : statusCode: ' + resCampaign.statusCode + ', message: ' + resCampaign.message);
                                        }
                                    }
                                }
                                statusError.push(statusCampaignId);

                                //-------------------------------

                                if(!statusLang || !colEventDate || !statusSlug || !statusCampaignId) {
                                    excelArrError.push({
                                        lang: {
                                            data: colLang,
                                            status: statusLang,
                                        },
                                        eventDate: {
                                            data: colEventDate,
                                            status: statusEventDate,
                                        },
                                        campaignId: {
                                            data: colCampaignId,
                                            status: statusCampaignId
                                        },
                                        campaignName: {
                                            data: campaignName
                                        },
                                        apData: {
                                            url : colUrl,
                                            slug: colSlug,
                                            status: statusSlug,
                                            message: message
                                        }
                                    });
                                }

                                excelArrAll.push({
                                    lang: {
                                        data: colLang,
                                        status: statusLang,
                                    },
                                    eventDate: {
                                        data: colEventDate,
                                        status: statusEventDate,
                                    },
                                    campaignId: {
                                        data: colCampaignId,
                                        status: statusCampaignId
                                    },
                                    campaignName: {
                                        data: campaignName
                                    },
                                    apData: {
                                        url : colUrl,
                                        slug: colSlug,
                                        status: statusSlug,
                                        message: message
                                    }
                                });
                            }

                            setExcelSpecialPreview(excelArrAll);
                            setExcelSpecialPreviewError(excelArrError);
                            if(excelArrAll && excelArrAll.length > 0) {
                                if(excelArrError && excelArrError.length > 0) {
                                    setDisableImport(true);
                                }
                                else {
                                    setDisableImport(false);
                                }
                                toast.success("Generate Result เรียบร้อย");
                            }
                            else {
                                toast.error("Generate ไม่สำเร็จ กรุณาตรวจสอบข้อมูลใน Excel อีกครั้ง");
                            }
                        }
                    }
                    setUploading(false);
                    setUploaded(true);
                };
                reader.readAsBinaryString(file);
            }

        } else {
            toast.error("กรุณาระบุ Excel File");
        }
    }

    async function uploadStaticPage() {
        if (excelFile && excelFile.target.value) {

            if (!excelFile || typeof excelFile.target === 'undefined') {
                toast.error("กรุณาระบุ Excel File");
            }
            else {
                setUploading(true);

                const [file] = excelFile.target.files;
                const reader = new FileReader();

                reader.onload = async (evt) => {
                    const bstr = evt.target.result;
                    const wb = XLSX.read(bstr, {type: "binary"});
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];
                    const data = XLSX.utils.sheet_to_csv(ws, {header: 1});

                    if(data) {
                        let row = data.split('\n');
                        let header = row[0];
                        let cols = header.split(',');
                        if(cols[0] !== 'Lang') {
                            setUploading(false);
                            toast.error("Column 1 : ต้องเป็น(ชื่อ) Lang");
                        }
                        else if(cols[1] !== 'Slug') {
                            setUploading(false);
                            toast.error("Column 2 : ต้องเป็น(ชื่อ) Slug");
                        }
                        else if(cols[2] !== 'Campaign ID') {
                            setUploading(false);
                            toast.error("Column 3 : ต้องเป็น(ชื่อ) Campaign ID");
                        }
                        else {
                            let excelArrAll = [];
                            let excelArrError = [];
                            let statusError = [];
                            for(let i=1;i<row.length;i++) {
                                let cols = row[i].split(',');
                                let colUrl = null;
                                let colLang = cols[0].toString().trim();
                                let colSlug = cols[1].toString().trim();
                                let colCampaignId = cols[2].toString().trim();

                                let message = [];

                                //-------------------------------

                                let statusLang = false;
                                if(lang) {
                                    statusLang = lang.filter(e => e.id === colLang).length > 0;
                                }
                                if(!colLang) {
                                    message.push('Please input Lang');
                                }
                                if(!statusLang) {
                                    message.push('Invalid Lang');
                                }
                                statusError.push(statusLang);

                                //-------------------------------

                                let statusSlug = false;
                                if(!colSlug) {
                                    message.push('Please input Slug');
                                }
                                else {
                                    if(colLang) {
                                        const resWebpage= await Utils.getStaticPageImport({
                                            langId: colLang
                                        });
                                        let checkSlug = resWebpage.data.filter(e => e.web_page === colSlug);
                                        if(checkSlug) {
                                            statusSlug = checkSlug.length > 0;
                                            if(statusSlug) {
                                                colUrl = checkSlug[0].web_url;
                                            }
                                        }
                                    }
                                    if(!statusSlug) {
                                        message.push('Invalid Slug');
                                    }
                                }
                                statusError.push(statusSlug);

                                //-------------------------------

                                let statusCampaignId = false;
                                let campaignName = '';
                                if(colUrl && colSlug) {
                                    if(colCampaignId === '0638A01') {
                                        statusCampaignId = true;
                                        campaignName = 'NonDefine';
                                    }
                                    else {
                                        const resCampaign = await Utils.getListSubCampaignImport();
                                        if (resCampaign.statusCode === 200 || resCampaign.message === 'success') {
                                            if (resCampaign.campaign && resCampaign.campaign.length > 0) {
                                                let campaignList = resCampaign.campaign;
                                                let campaignRow = campaignList.filter(e => e.sub_campaign_id === colCampaignId)[0];
                                                if (campaignRow && campaignRow.sub_campaign_id) {
                                                    statusCampaignId = true;
                                                    campaignName = campaignRow.sub_campaign_name;
                                                } else {
                                                    statusCampaignId = false;
                                                    message.push('Invalid Campaign ID');
                                                }
                                            } else {
                                                message.push('API /api/cm/listsubcampaign : Not found data');
                                            }
                                        } else {
                                            message.push('API /api/cm/listsubcampaign : statusCode: ' + resCampaign.statusCode + ', message: ' + resCampaign.message);
                                        }
                                    }
                                }
                                statusError.push(statusCampaignId);

                                //-------------------------------

                                if(!statusLang || !statusSlug || !statusCampaignId) {
                                    excelArrError.push({
                                        lang: {
                                            data: colLang,
                                            status: statusLang,
                                        },
                                        campaignId: {
                                            data: colCampaignId,
                                            status: statusCampaignId
                                        },
                                        campaignName: {
                                            data: campaignName
                                        },
                                        apData: {
                                            url : colUrl,
                                            slug: colSlug,
                                            status: statusSlug,
                                            message: message
                                        }
                                    });
                                }

                                excelArrAll.push({
                                    lang: {
                                        data: colLang,
                                        status: statusLang,
                                    },
                                    campaignId: {
                                        data: colCampaignId,
                                        status: statusCampaignId
                                    },
                                    campaignName: {
                                        data: campaignName
                                    },
                                    apData: {
                                        url : colUrl,
                                        slug: colSlug,
                                        status: statusSlug,
                                        message: message
                                    }
                                });
                            }

                            setExcelSpecialPreview(excelArrAll);
                            setExcelSpecialPreviewError(excelArrError);
                            if(excelArrAll && excelArrAll.length > 0) {
                                if(excelArrError && excelArrError.length > 0) {
                                    setDisableImport(true);
                                }
                                else {
                                    setDisableImport(false);
                                }
                                toast.success("Generate Result เรียบร้อย");
                            }
                            else {
                                toast.error("Generate ไม่สำเร็จ กรุณาตรวจสอบข้อมูลใน Excel อีกครั้ง");
                            }
                        }
                    }
                    setUploading(false);
                    setUploaded(true);
                };
                reader.readAsBinaryString(file);
            }

        } else {
            toast.error("กรุณาระบุ Excel File");
        }
    }

    return (
        <main><Toaster position="bottom-right" />
            <div className="row table-toolbar mb-2">
                <div className="col-6 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Generate Ads Set Naming Multiple</div>
                    <span className="ms-1">/</span> <span className="text-muted">Listing</span>
                </div>
                <div className="col-6 text-end align-self-center toolbars">
                    <NavLink className="btn btn-sm btn-light me-2" to='/adsNamingCampaign'><span><Icon.ArrowLeft/> กลับไป</span></NavLink>
                </div>
            </div>
            <div className="rounded bg-white p-4 shadow">
                <div className="row">
                    <h6><Icon.Upload size={16} /> Export Empty Template</h6>
                    <div className="col-12">
                        <form className="row g-3">
                            <div className="col-12 col-md-8">
                                <label htmlFor="typeIed" className="form-label">Type <span className="text-danger">*</span></label>
                                <div className="row">
                                    <div className="col-6">
                                        <Select
                                            isClearable={true}
                                            classNamePrefix="form-select-search"
                                            options={type}
                                            onChange={(event) => onChangeTypeId(event)}
                                            value={typeId}
                                            getOptionValue={(option) => `${option.id}`}
                                            getOptionLabel={(option) => `${option.name}`}
                                        />
                                    </div>
                                    <div className="col-6">
                                        <button type="button" className="btn btn-success" onClick={onDownload}><span
                                            className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span>{isLoading ? btnTextLoading : btnTextDefault}</button>

                                        <a href="https://drive.google.com/drive/folders/1wF9-2YAHtXs7CALrA_3gGsXPyBBM_LnZ" target="_blank" className="btn btn-warning ms-2">คู่มือการใช้งาน</a>
                                    </div>
                                </div>
                            </div>

                            <div className={"col-md-6" + (typeId && typeId.id === Utils.ADSNAMING_GROUP_SPECIAL ? '':' d-none')}>
                                <label htmlFor="langId" className="form-label">Special Type <span className="text-danger">*</span></label>
                                <div className="row">
                                    <div className="col-sm-6">
                                        <div className="form-check">
                                            <input className="form-check-input" type="radio" name="urlType"
                                                   id="urlType1" checked={!isCustomUrl} onChange={e => onChangeCustomUrl(false)} />
                                            <label className="form-check-label" htmlFor="urlType1">
                                                AP Special
                                            </label>
                                        </div>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="form-check">
                                            <input className="form-check-input" type="radio" name="urlType"
                                                   id="urlType2" checked={isCustomUrl} onChange={e => onChangeCustomUrl(true)} />
                                            <label className="form-check-label" htmlFor="urlType2">
                                                Custom URL
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={"col-md-6 mt-3" + (typeId && typeId.id === Utils.ADSNAMING_GROUP_SPECIAL && !isCustomUrl ? '':' d-none')}>
                                <label htmlFor="specialFilter" className={"form-label" + (isCustomUrl ? ' d-none':'')}>Filter Type <span className="text-danger">*</span></label>
                                <Select
                                    classNamePrefix="form-select-search"
                                    options={specialFilter}
                                    onChange={(event) => onChangeFilterTypeId(event)}
                                    value={specialFilterId}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.id} : ${option.name}`}
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {/* ----- UPLOAD ----- */}
            <div className="rounded bg-white p-4 shadow mt-3">
                <div className="row">
                    <h6><Icon.Download size={16} /> Import Template Data</h6>
                    <div className="col-12">
                        <form className="row g-3">
                            <div className="col-12 col-md-6">
                                <label htmlFor="group" className="form-label">Group <span className="text-danger">*</span></label>
                                <Select
                                    isClearable={false}
                                    isDisabled={!adsGroup || adsGroup.length < 0}
                                    classNamePrefix="form-select-search"
                                    options={adsGroup}
                                    onChange={(event) => onChangeGroupId(event)}
                                    value={adsGroupId}
                                    getOptionValue={(option) => `${option.id}`}
                                    getOptionLabel={(option) => `${option.name}`}
                                />
                            </div>

                            <div className="col-12 mt-3 p-2">
                                <div className="fw-bold py-2 ps-2 bg-yellow-light">Group URL</div>
                                <table className="table table-bordered table-yellow">
                                    <thead>
                                    <tr>
                                        <th width="150">Name</th>
                                        <th>Format</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        previewParams && previewParams.length ?
                                            previewParams.map((row, index) => {
                                                return (<tr key={index}><td>{row.itemName}</td><td>{row.params}</td></tr>)
                                            }) : null
                                    }
                                    </tbody>
                                </table>
                            </div>

                            <div className="col-12 col-md-8">
                                <label htmlFor="excelFilex" className={"form-label " + (isUploaded ? 'd-none':'d-block')}>Excel File <span className="text-danger">*</span></label>
                                <div className="row">
                                    <div className={"col-8 " + (isUploaded ? 'd-none':'d-block')}>
                                        <div className="input-group mb-3">
                                            <input type="file" className="form-control" id="excelFile" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" onChange={(e) => {onSelectFile(e)}} />
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <button type="button" className={"btn btn-primary " + (isUploaded ? 'd-none':'d-block')} onClick={onUpload} disabled={isUploading}><span
                                            className={isUploading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {isUploading ? btnTextUploading : btnTextUploadDefault}</button>
                                        <button type="button" className={"btn btn-secondary " + (!isUploaded ? 'd-none':'d-block')} onClick={resetUpload}>เริ่มใหม่</button>
                                    </div>
                                </div>
                            </div>

                            <div className="col-12">
                                <div className="fw-bold py-2 ps-2 bg-green-light">Generate Result</div>
                                <div style={{maxHeight: '600px', overflowY: 'auto'}}>
                                    <table className={"table table-bordered table-green" + (showExcelAlwaysOnPreview && typeId && typeId.id === Utils.ADSNAMING_GROUP_ALWAYS_ON ? '':' d-none')}>
                                        <thead>
                                        <tr>
                                            <th className="text-center" width="60">Lang <span className="text-danger">*</span></th>
                                            <th width="100" className="text-center">Project Type <span className="text-danger">*</span></th>
                                            <th width="120" className="text-center">Project Code <span className="text-danger">*</span></th>
                                            <th width="100" className="text-center">Campaign ID</th>
                                            <th width="120" className="text-center">Campaign Date</th>
                                            <th>URL</th>
                                            <th>Project Slug</th>
                                            <th className="text-center" width="60">Status</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            showExcelAlwaysOnPreviewError.length ?
                                                showExcelAlwaysOnPreviewError.map((row, index) => {
                                                    return (<tr key={index} className={""+ (row.status !== 1 ? ' bg-danger-light' : '')}>
                                                        <td className={"text-center" + (!row.statusLang ? ' text-danger':'')}>{row.lang}</td>
                                                        <td className={"text-center" + (!row.statusProjectType ? ' text-danger':'')}>{row.projectType}</td>
                                                        <td className={"text-center" + (!row.statusProjectCode ? ' text-danger':'')}>{row.projectCode}</td>
                                                        <td className={"text-center" + (!row.statusCampaignId ? ' text-danger':'')}>{row.campaignId}</td>
                                                        <td className={"text-center" + (!row.statusCampaignDate ? ' text-danger':'')}>{row.campaignDate}</td>
                                                        <td className={"text-left" + (row.apStatus ? ' text-danger':'')}>{row.apStatus ? row.apStatus: row.url}</td>
                                                        <td className="text-center">{row.projectSlug}</td>
                                                        <td className={"text-center " + (row.status === 1 ? ' text-success' : ' text-danger')}>{row.status === 1 ? <Icon.CheckCircle /> : row.status !== 1 ? <Icon.XCircle />:''}</td>
                                                    </tr>)
                                                }) : null
                                        }
                                        {
                                            showExcelAlwaysOnPreview.length ?
                                                showExcelAlwaysOnPreview.map((row, index) => {
                                                    return (<tr key={index} className={""+ (row.status !== 1 ? ' bg-danger-light' : '')}>
                                                        <td className={"text-center" + (!row.statusLang ? ' text-danger':'')}>{row.lang}</td>
                                                        <td className={"text-center" + (!row.statusProjectType ? ' text-danger':'')}>{row.projectType}</td>
                                                        <td className={"text-center" + (!row.statusProjectCode ? ' text-danger':'')}>{row.projectCode}</td>
                                                        <td className={"text-center" + (!row.statusCampaignId ? ' text-danger':'')}>{row.campaignId}</td>
                                                        <td className={"text-center" + (!row.statusCampaignDate ? ' text-danger':'')}>{row.campaignDate}</td>
                                                        <td className={"text-left" + (row.apStatus ? ' text-danger':'')}>{row.apStatus ? row.apStatus: row.url}</td>
                                                        <td className="text-center">{row.projectSlug}</td>
                                                        <td className={"text-center " + (row.status === 1 ? ' text-success' : ' text-danger')}>{row.status === 1 ? <Icon.CheckCircle /> : row.status !== 1 ? <Icon.XCircle />:''}</td>
                                                    </tr>)
                                                }) : null
                                        }
                                        </tbody>
                                    </table>

                                    <table className={"table table-bordered table-green" + (showExcelAdHocPreview && typeId && typeId.id === Utils.ADSNAMING_GROUP_ADHOC_CAMPAIGN ? '':' d-none')}>
                                        <thead>
                                        <tr>
                                            <th className="text-center" width="60">Lang <span className="text-danger">*</span></th>
                                            <th className="text-center" width="100">BU Type <span className="text-danger">*</span></th>
                                            <th className="text-center" width="120">Campaign Type <span className="text-danger">*</span></th>
                                            <th className="text-center" width="100">Campaign ID <span className="text-danger">*</span></th>
                                            <th className="text-center" width="110">Campaign Date</th>
                                            <th>URL</th>
                                            <th>Promotion Slug</th>
                                            <th className="text-center" width="60">Status</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            showExcelAdHocPreviewError.length ?
                                                showExcelAdHocPreviewError.map((row, index) => {
                                                    return (<tr key={index} className={""+ (row.status !== 1 ? ' bg-danger-light' : '')}>
                                                        <td className={"text-center" + (!row.statusLang ? ' text-danger':'')}>{row.lang}</td>
                                                        <td className={"text-center" + (!row.statusBuType ? ' text-danger':'')}>{row.buType}</td>
                                                        <td className={"text-center" + (!row.statusCampaignType ? ' text-danger':'')}>{row.campaignType}</td>
                                                        <td className={"text-center" + (!row.statusCampaignId ? ' text-danger':'')}>{row.campaignId}</td>
                                                        <td className={"text-center" + (!row.statusCampaignDate ? ' text-danger':'')}>{row.campaignDate}</td>
                                                        <td className={"text-left" + (row.apStatus ? ' text-danger':'')}>{row.apStatus ? row.apStatus: row.url}</td>
                                                        <td className="text-center">{row.promotionSlug}</td>
                                                        <td className={"text-center " + (row.status === 1 ? ' text-success' : ' text-danger')}>{row.status === 1 ? <Icon.CheckCircle /> : row.status !== 1 ? <Icon.XCircle />:''}</td>
                                                    </tr>)
                                                }) : null
                                        }
                                        {
                                            showExcelAdHocPreview.length ?
                                                showExcelAdHocPreview.map((row, index) => {
                                                    return (<tr key={index} className={""+ (row.status !== 1 ? ' bg-danger-light' : '')}>
                                                        <td className={"text-center" + (!row.statusLang ? ' text-danger':'')}>{row.lang}</td>
                                                        <td className={"text-center" + (!row.statusBuType ? ' text-danger':'')}>{row.buType}</td>
                                                        <td className={"text-center" + (!row.statusCampaignType ? ' text-danger':'')}>{row.campaignType}</td>
                                                        <td className={"text-center" + (!row.statusCampaignId ? ' text-danger':'')}>{row.campaignId}</td>
                                                        <td className={"text-center" + (!row.statusCampaignDate ? ' text-danger':'')}>{row.campaignDate}</td>
                                                        <td className={"text-left" + (row.apStatus ? ' text-danger':'')}>{row.apStatus ? row.apStatus: row.url}</td>
                                                        <td className="text-center">{row.promotionSlug}</td>
                                                        <td className={"text-center " + (row.status === 1 ? ' text-success' : ' text-danger')}>{row.status === 1 ? <Icon.CheckCircle /> : row.status !== 1 ? <Icon.XCircle />:''}</td>
                                                    </tr>)
                                                }) : null
                                        }
                                        </tbody>
                                    </table>

                                    {
                                        typeId && typeId.id === Utils.ADSNAMING_GROUP_SPECIAL && isCustomUrl  ?
                                            <>
                                                <table className="table table-bordered table-green">
                                                    <thead>
                                                    <tr>
                                                        <th className="text-center" width="60">URL</th>
                                                        <th width="100" className="text-center">Slug</th>
                                                        <th width="100" className="text-center">Campaign ID</th>
                                                        <th className="text-center" width="60">Status</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {
                                                        showExcelSpecialPreview.length ?
                                                            showExcelSpecialPreview.map((row, index) => {
                                                                let status = row.apData.status && row.campaignId.status;
                                                                return (
                                                                    <tr key={index} className={""+ (!status ? ' bg-danger-light' : '')}>
                                                                        <td className={"text-left" + (!row.apData.status || row.apData.message.length > 0 ? ' text-danger':'')} style={{ whiteSpace: 'pre-line' }}>{status ? row.apData.url : (row.apData.message ? row.apData.message.join('\n') : '')}</td>
                                                                        <td className="text-center">{row.apData.slug}</td>
                                                                        <td className={"text-center" + (!row.campaignId.status ? ' text-danger':'')}>{row.campaignId.data ? row.campaignId.data : 'กรุณาระบุ'}</td>
                                                                        <td className={"text-center " + (status ? ' text-success' : ' text-danger')}>{status ? <Icon.CheckCircle /> : <Icon.XCircle />}</td>
                                                                    </tr>
                                                                )
                                                            }) : null
                                                    }
                                                    {
                                                        showExcelSpecialPreviewError.length === 0 && showExcelSpecialPreview.length === 0 && !isUploading ? <tr><td colSpan={4} className="text-center">-</td></tr>:''
                                                    }
                                                    {
                                                        isUploading ?  <tr><td colSpan={4} className="text-center"><span className="spinner-grow spinner-grow-sm"></span></td></tr>:''
                                                    }
                                                    </tbody>
                                                </table>
                                            </> : ''
                                    }

                                    {
                                        typeId && typeId.id === Utils.ADSNAMING_GROUP_SPECIAL && !isCustomUrl && specialFilterId && specialFilterId.id === Utils.ADS_NAMING_SPECIAL_FILTER_BG_ZONE ?
                                            <>
                                                <table className="table table-bordered table-green">
                                                    <thead>
                                                    <tr>
                                                        <th className="text-center" width="60">URL</th>
                                                        <th width="100" className="text-center">Slug</th>
                                                        <th width="100" className="text-center">Lang</th>
                                                        <th width="100" className="text-center">Zone Project</th>
                                                        <th width="100" className="text-center">Zone Status</th>
                                                        <th width="100" className="text-center">Campaign ID</th>
                                                        <th className="text-center" width="60">Status</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {
                                                        showExcelSpecialPreview.length ?
                                                            showExcelSpecialPreview.map((row, index) => {
                                                                let status = row.apData.status && row.zoneProject.status && row.zoneStatus.status && row.campaignId.status;
                                                                return (
                                                                    <tr key={index} className={""+ (!status ? ' bg-danger-light' : '')}>
                                                                        <td className={"text-left" + (!row.apData.status || row.apData.message.length > 0 ? ' text-danger':'')} style={{ whiteSpace: 'pre-line' }}>{status ? row.apData.url : (row.apData.message ? row.apData.message.join('\n') : '')}</td>
                                                                        <td className="text-center">{row.apData.slug}</td>
                                                                        <td className={"text-center" + (!row.lang.status ? ' text-danger':'')}>{row.lang.data}</td>
                                                                        <td className={"text-center" + (!row.zoneProject.status ? ' text-danger':'')}>{row.zoneProject.data}</td>
                                                                        <td className={"text-center" + (!row.zoneStatus.status ? ' text-danger':'')}>{row.zoneStatus.data}</td>
                                                                        <td className={"text-center" + (!row.campaignId.status ? ' text-danger':'')}>{row.campaignId.data ? row.campaignId.data : 'กรุณาระบุ'}</td>
                                                                        <td className={"text-center " + (status ? ' text-success' : ' text-danger')}>{status ? <Icon.CheckCircle /> : <Icon.XCircle />}</td>
                                                                    </tr>
                                                                )
                                                            }) : null
                                                    }
                                                    {
                                                        showExcelSpecialPreviewError.length === 0 && showExcelSpecialPreview.length === 0 && !isUploading ? <tr><td colSpan={7} className="text-center">-</td></tr>:''
                                                    }
                                                    {
                                                        isUploading ?  <tr><td colSpan={7} className="text-center"><span className="spinner-grow spinner-grow-sm"></span></td></tr>:''
                                                    }
                                                    </tbody>
                                                </table>
                                            </> : ''
                                    }

                                    {
                                        typeId && typeId.id === Utils.ADSNAMING_GROUP_SPECIAL && !isCustomUrl && specialFilterId && specialFilterId.id === Utils.ADS_NAMING_SPECIAL_FILTER_COMBINE_ZONE ?
                                            <>
                                                <table className="table table-bordered table-green">
                                                    <thead>
                                                    <tr>
                                                        <th className="text-center" width="60">URL</th>
                                                        <th width="100" className="text-center">Slug</th>
                                                        <th width="100" className="text-center">Lang</th>
                                                        <th width="100" className="text-center">Zone Status</th>
                                                        <th width="100" className="text-center">Campaign ID</th>
                                                        <th className="text-center" width="60">Status</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {
                                                        showExcelSpecialPreview.length ?
                                                            showExcelSpecialPreview.map((row, index) => {
                                                                let status = row.apData.status && row.zoneStatus.status && row.campaignId.status;
                                                                return (
                                                                    <tr key={index} className={""+ (!status ? ' bg-danger-light' : '')}>
                                                                        <td className={"text-left" + (!row.apData.status || row.apData.message.length > 0 ? ' text-danger':'')} style={{ whiteSpace: 'pre-line' }}>{status ? row.apData.url : (row.apData.message ? row.apData.message.join('\n') : '')}</td>
                                                                        <td className="text-center">{row.apData.slug}</td>
                                                                        <td className={"text-center" + (!row.lang.status ? ' text-danger':'')}>{row.lang.data}</td>
                                                                        <td className={"text-center" + (!row.zoneStatus.status ? ' text-danger':'')}>{row.zoneStatus.data}</td>
                                                                        <td className={"text-center" + (!row.campaignId.status ? ' text-danger':'')}>{row.campaignId.data ? row.campaignId.data : 'กรุณาระบุ'}</td>
                                                                        <td className={"text-center " + (status ? ' text-success' : ' text-danger')}>{status ? <Icon.CheckCircle /> : <Icon.XCircle />}</td>
                                                                    </tr>
                                                                )
                                                            }) : null
                                                    }
                                                    {
                                                        showExcelSpecialPreviewError.length === 0 && showExcelSpecialPreview.length === 0 && !isUploading ? <tr><td colSpan={6} className="text-center">-</td></tr>:''
                                                    }
                                                    {
                                                        isUploading ?  <tr><td colSpan={6} className="text-center"><span className="spinner-grow spinner-grow-sm"></span></td></tr>:''
                                                    }
                                                    </tbody>
                                                </table>
                                            </> : ''
                                    }

                                    {
                                        typeId && typeId.id === Utils.ADSNAMING_GROUP_SPECIAL && !isCustomUrl && specialFilterId && specialFilterId.id === Utils.ADS_NAMING_SPECIAL_FILTER_EVENT_REMINDER ?
                                            <>
                                                <table className="table table-bordered table-green">
                                                    <thead>
                                                    <tr>
                                                        <th className="text-center" width="60">URL</th>
                                                        <th width="100" className="text-center">Slug</th>
                                                        <th width="100" className="text-center">Lang</th>
                                                        <th width="100" className="text-center">Event Date</th>
                                                        <th width="100" className="text-center">Campaign ID</th>
                                                        <th className="text-center" width="60">Status</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {
                                                        showExcelSpecialPreview.length ?
                                                            showExcelSpecialPreview.map((row, index) => {
                                                                let status = row.apData.status && row.eventDate.status && row.campaignId.status;
                                                                return (
                                                                    <tr key={index} className={""+ (!status ? ' bg-danger-light' : '')}>
                                                                        <td className={"text-left" + (!row.apData.status || row.apData.message.length > 0 ? ' text-danger':'')} style={{ whiteSpace: 'pre-line' }}>{status ? row.apData.url : (row.apData.message ? row.apData.message.join('\n') : '')}</td>
                                                                        <td className="text-center">{row.apData.slug}</td>
                                                                        <td className={"text-center" + (!row.lang.status ? ' text-danger':'')}>{row.lang.data}</td>
                                                                        <td className={"text-center" + (!row.eventDate.status ? ' text-danger':'')}>{row.eventDate.data}</td>
                                                                        <td className={"text-center" + (!row.campaignId.status ? ' text-danger':'')}>{row.campaignId.data ? row.campaignId.data : 'กรุณาระบุ'}</td>
                                                                        <td className={"text-center " + (status ? ' text-success' : ' text-danger')}>{status ? <Icon.CheckCircle /> : <Icon.XCircle />}</td>
                                                                    </tr>
                                                                )
                                                            }) : null
                                                    }
                                                    {
                                                        showExcelSpecialPreviewError.length === 0 && showExcelSpecialPreview.length === 0 && !isUploading ? <tr><td colSpan={6} className="text-center">-</td></tr>:''
                                                    }
                                                    {
                                                        isUploading ?  <tr><td colSpan={6} className="text-center"><span className="spinner-grow spinner-grow-sm"></span></td></tr>:''
                                                    }
                                                    </tbody>
                                                </table>
                                            </> : ''
                                    }

                                    {
                                        typeId && typeId.id === Utils.ADSNAMING_GROUP_SPECIAL && !isCustomUrl && specialFilterId && specialFilterId.id === Utils.ADS_NAMING_SPECIAL_FILTER_STATIC_PAGE ?
                                            <>
                                                <table className="table table-bordered table-green">
                                                    <thead>
                                                    <tr>
                                                        <th className="text-center" width="60">URL</th>
                                                        <th width="100" className="text-center">Slug</th>
                                                        <th width="100" className="text-center">Lang</th>
                                                        <th width="100" className="text-center">Campaign ID</th>
                                                        <th className="text-center" width="60">Status</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {
                                                        showExcelSpecialPreview.length ?
                                                            showExcelSpecialPreview.map((row, index) => {
                                                                let status = row.apData.status && row.campaignId.status;
                                                                return (
                                                                    <tr key={index} className={""+ (!status ? ' bg-danger-light' : '')}>
                                                                        <td className={"text-left" + (!row.apData.status || row.apData.message.length > 0 ? ' text-danger':'')} style={{ whiteSpace: 'pre-line' }}>{status ? row.apData.url : (row.apData.message ? row.apData.message.join('\n') : '')}</td>
                                                                        <td className="text-center">{row.apData.slug}</td>
                                                                        <td className={"text-center" + (!row.lang.status ? ' text-danger':'')}>{row.lang.data}</td>
                                                                        <td className={"text-center" + (!row.campaignId.status ? ' text-danger':'')}>{row.campaignId.data ? row.campaignId.data : 'กรุณาระบุ'}</td>
                                                                        <td className={"text-center " + (status ? ' text-success' : ' text-danger')}>{status ? <Icon.CheckCircle /> : <Icon.XCircle />}</td>
                                                                    </tr>
                                                                )
                                                            }) : null
                                                    }
                                                    {
                                                        showExcelSpecialPreviewError.length === 0 && showExcelSpecialPreview.length === 0 && !isUploading ? <tr><td colSpan={6} className="text-center">-</td></tr>:''
                                                    }
                                                    {
                                                        isUploading ?  <tr><td colSpan={6} className="text-center"><span className="spinner-grow spinner-grow-sm"></span></td></tr>:''
                                                    }
                                                    </tbody>
                                                </table>
                                            </> : ''
                                    }
                                </div>
                                <div className="mt-3">
                                    <button type="button" className={"btn btn-success mt-3 " + (disableImport ? ' d-none':'')} onClick={onGenerateUTM} disabled={isImporting}><span
                                        className={isImporting ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> <Icon.CloudArrowUp siize={16} /> {isImporting ? btnTextImporting : btnTextImportDefault}</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </main>
    );
}